import React from "react";
import { Callout, LongTextLabel } from "@sscs/ui";
import { CommentIcon } from "@sscs/ui/icons";
import { getClassName } from "@sscs/utils";
import styles from "./overrideReason.module.scss";

type OverrideReasonProps = {
  reason: string;
  overrideWarning?: string;
  hasUnsavedRevert: boolean;
};

const OverrideReason = ({
  reason,
  overrideWarning,
  hasUnsavedRevert,
}: OverrideReasonProps): React.JSX.Element => {
  return (
    <div
      className={getClassName(styles["override-reason"], {
        [styles["unsaved-revert-reason"]]: hasUnsavedRevert,
      })}
    >
      <div className={styles["override-reason-content"]}>
        <CommentIcon className={styles.icon} />
        <LongTextLabel label={reason} />
      </div>
      {overrideWarning && (
        <Callout
          type="error"
          variant="inline"
          className={styles["override-reason-warning"]}
          title={<LongTextLabel label={overrideWarning} />}
        />
      )}
    </div>
  );
};
export default OverrideReason;
